// extracted by mini-css-extract-plugin
module.exports = {"icon":"InfoTip_icon__39al3"};